export default {
	addresses: 'Addresses',
	'contact-information': 'Contact Information',
	'contact-info': 'Contact info',

	contactInfoTypes: {
		phone: 'Phone',
		landline: 'Landline',
		email: 'Email',
		facebook: 'Facebook',
		twitter: 'X (Twitter)',
		whatsApp: 'WhatsApp',
		telegram: 'Telegram',
		linkedIn: 'LinkedIn',
		website: 'Website',
	},

	'creation-customer-request': 'creation customer request',
	'modification-customer-request': 'modification customer request',
	'deletion-customer-request': 'Deletion customer request',

	'the-request-is-sent': 'The request is sent',

	'no-customers-to-show': 'NO CUSTOMERS TO SHOW',

	'add-location': 'Add location',
}